import { Component, Input } from '@angular/core'
import { SearchComponent } from '../../../components/search/search.component'
import { ActivatedRoute, Router, RouterLink } from '@angular/router'
import { MatIcon } from '@angular/material/icon'
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
} from '@angular/material/table'
import { NgxPaginationModule } from 'ngx-pagination'
import { AsyncPipe, DatePipe, NgFor, NgIf, SlicePipe } from '@angular/common'
import { MatMenuModule } from '@angular/material/menu'
import { MatNavList } from '@angular/material/list'
import { Incident } from '../../../models/incident.interface'
import { Observable } from 'rxjs/internal/Observable'
import { Pagination } from '../../../models/pagination.interface'
import { LayoutService } from '../../../services/layout/layout.service'
import { IncidentService } from '../../../services/incident/incident.service'
import { ToastrService } from 'ngx-toastr'
import { UploadfileService } from '../../../services/uploadfile/uploadfile.service'
import { MatDialog } from '@angular/material/dialog'
import { LoadingService } from '../../../services/loadingService/loading.service'
import { catchError, filter, map, switchMap, tap } from 'rxjs'
import { PAGINATION } from '../../../shared/constants'
import { Filter, QueryGet } from '../../../shared/query-types'
import { EncryptDataComponent } from '../../encrypt-data/encrypt-data.component'
import { ProfileService } from '../../../services/profile/profile.service'
import { GroupService } from '../../../services/group/group.service'
import { Profile } from '../../../models/users.interface'
import { IncidentDetailMadejaComponent } from '../incident-detail-madeja/incident-detail-madeja.component'
import { Title } from '@angular/platform-browser'
import { ExportIncidentComponent } from '../export-incident/export-incident.component'

@Component({
    selector: 'app-list-incident-madeja',
    standalone: true,
    imports: [
        MatIcon,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        NgxPaginationModule,
        AsyncPipe,
        SearchComponent,
        MatMenuModule,
        RouterLink,
        NgIf,
        NgFor,
        SlicePipe,
        MatNavList,
        DatePipe
    ],
    templateUrl: './list-incident-madeja.component.html',
    styleUrl: './list-incident-madeja.component.css',
})
export class ListIncidentMadejaComponent {
    public page: number | undefined
    @Input() filtro: string = ''
    @Input() orden: string = ''
    limit = 10
    total = 0
    incidentList: Incident[] = []
    private userProfile: Profile | null = null
    grupoLogueado: string | null = null
    asyncIncident!: Observable<Pagination<Incident[]>>
    selectedIncident: Incident | null = null
    showColumns: string[] = [
        'acciones',
        'code',
        'violence',
        'description',
        'date',
        'createdAt',
        'witnesses',
        'victim',
        'perpetror',
        'location',
        'organization',
        'geoRef',
        'file',
    ]

    constructor(
        private layoutService: LayoutService,
        private activatedRouter: ActivatedRoute,
        private incidentService: IncidentService,
        private router: Router,
        private toastr: ToastrService,
        private uploadfileService: UploadfileService,
        private dialog: MatDialog,
        private loadingService: LoadingService,
        private profileService: ProfileService,
        private groupService: GroupService,
        private title: Title
    ) {
        this.title.setTitle('Sucesos')
    }

    private expanded = new Set<string>()
    private getKey(incident: Incident): string {
        return String(incident?.description)
    }
    isExpanded(incident: Incident): boolean {
        return this.expanded.has(this.getKey(incident))
    }
    toggleExpand(incident: Incident): void {
        const key = this.getKey(incident)
        if (this.expanded.has(key)) this.expanded.delete(key)
        else this.expanded.add(key)
    }

    ngOnInit(): void {
        this.profileService.userProfile$
            .pipe(
                filter((profile): profile is Profile => profile !== null),
                tap((user) => {
                    this.userProfile = user
                    this.grupoLogueado = this.groupService.getFirstGroup(user)
                }),
                switchMap(() => this.layoutService.paginationLimit$),
                switchMap((limit) => {
                    this.limit = limit
                    return this.activatedRouter.queryParamMap
                }),
                tap((params) => {
                    const pageNum = params.get('page') || '1'
                    const search = params.get('search') || ''
                    this.page = parseInt(pageNum)
                    this.fetchIncident(PAGINATION.first_page, null, search)
                })
            )
            .subscribe()
    }

    fetchIncident(
        page: number,
        filter: Filter | null = null,
        search = ''
    ): void {
        const offset = page > 1 ? page * this.limit - this.limit : 0
        const filters: Filter[] = [{ name: 'isActive', value: 1 }]

        if (this.grupoLogueado) {
            filters.push({
                name: 'role_group__name',
                value: this.grupoLogueado,
            })
        }
        const params: QueryGet = {
            order: '-id',
            limit: this.limit,
            offset,
            search,
            filters,
        }

        if (filter) {
            params.filters.push(filter)
        }
        this.page = page
        this.asyncIncident = this.incidentService.allIncidents(params).pipe(
            tap((response) => {
                this.incidentList = response.results
                this.incidentService.setIncidents(response.results)
                this.total = response.count
            }),
            map((res) => {
                this.loadingService.show(false)
                return res
            }),
            catchError((error) => {
                this.loadingService.show(false)
                this.router.navigate(['home/'])
                return []
            })
        )
    }

    openFile(incident: Incident): void {
        const id = incident?.fileAttach?.fileUrl
        const name = incident?.fileAttach?.fileName || 'archivo'
        this.uploadfileService.openPdfById(id, name).subscribe({
            error: () => {
                const msg = `No se pudo descargar o previsualizar el archivo`
                this.toastr.error(msg, 'Error', {
                    progressBar: true,
                    timeOut: 5000,
                })
            },
        })
    }

    hasFile(incident: Incident) {
        return (
            !!incident?.fileAttach?.fileUrl && !!incident?.fileAttach?.fileName
        )
    }

        exportIncident() {
        const dialogRef = this.dialog.open(ExportIncidentComponent, {
            width: 'auto',
            height: 'auto',
            maxHeight: '80vh',
        })
        dialogRef.afterClosed().subscribe(() => {})
    }

    openEncryptDialog(incident: Incident): void {
        const dialogRef = this.dialog.open(EncryptDataComponent, {
            width: '400px',
            data: { id: incident.id, secure: incident.secure },
        })
        dialogRef.afterClosed().subscribe(() => {
            this.fetchIncident(this.page || PAGINATION.first_page)
        })
    }

    incidentDetails(incident: Incident): void {
        this.selectedIncident = incident
        const dialogRef = this.dialog.open(IncidentDetailMadejaComponent, {
            data: { incident: this.selectedIncident },
            width: '80vw',
            maxWidth: '95vw',
            maxHeight: '90vh',
            panelClass: 'custom-dialog-container',
        })
        dialogRef.afterClosed().subscribe(() => {
            this.fetchIncident(this.page || PAGINATION.first_page)
        })
    }

    eliminate(incident: Incident): void {
        const confirmed = window.confirm(
            `¿Estás seguro de eliminar el incidente con ID ${incident.id}?`
        )
        if (!confirmed) return
        this.incidentService.deleteIncident(incident.id).subscribe({
            next: () => {
                const successMsg = `Eliminado CORRECTAMENTE!`
                this.toastr.success(successMsg, 'Exitoso!', {
                    progressBar: true,
                    timeOut: 5000,
                })
                this.fetchIncident(PAGINATION.first_page)
            },
            error: (err) => {
                this.toastr.error('No se pudo eliminar', 'Error', {
                    progressBar: true,
                    timeOut: 5000,
                })
            },
        })
    }
}
